import { useMutation } from '@tanstack/react-query'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'
import { useApiClientAccount } from '~/@api/client/useApiClientAccount'
import type { IDeleteBankAccountRequest } from '~/@api/generated-api-types-account/Api'

function useRemoveBankAccount() {
  const client = useApiClientAccount()

  async function deleteBankAccount(props: IDeleteBankAccountRequest) {
    return client.account
      .bankAccountControllerDelete(props, { secure: true })
      .then((res) => res.data)
  }

  const {
    mutate: deleteBankAccountMutation,
    isPending: isDeletingBankAccount,
    error,
  } = useMutation({
    mutationFn: deleteBankAccount,
  })

  return {
    deleteBankAccount: deleteBankAccountMutation,
    isDeletingBankAccount,
    error: getApiErrorMessage(error, 'Bankový účet sa nepodarilo odstrániť.'),
  }
}

export { useRemoveBankAccount }
